import React from "react";
import { Edit3, PhoneCall } from "lucide-react";
import { company } from "../mock";

const StickyBar = () => {
  const go = () => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2"
      style={{ boxShadow: "0px -6px 10px -2px rgba(0, 0, 0, 0.22)" }}
      data-testid="mobile-sticky-bar"
    >
      <button onClick={go} className="bg-fire text-white text-[16px] py-3 flex items-center justify-center gap-2 hover:text-charcoal transition-colors" data-testid="sticky-quote-button">
        <Edit3 size={18} /> Free Quote
      </button>
      <a href={company.phoneHref} className="text-white text-[16px] py-3 flex items-center justify-center gap-2" style={{ backgroundColor: "#343434" }} data-testid="sticky-call-button">
        <PhoneCall size={18} /> Call Us
      </a>
    </div>
  );
};

export default StickyBar;
